function getPropertyTypeValue(property_type) {
  switch (property_type) {
    case 'SINGLE_FAMILY':
      return 'Single-Family';
    case 'APARTMENT':
      return 'Apartment';
    case 'CONDO':
      return 'Condo';
    case 'MULTI_FAMILY':
      return 'Multi-Family';
    case 'MANUFACTURED':
      return 'Manufactured';
    case 'VACANT_LAND':
      return 'Vacant Land';
    case 'CO_OP':
      return 'Co-Op';
    case 'TOWNHOUSE':
      return 'Townhouse';
    case 'OTHER':
      return 'Other';
    default:
      return '';
  }
}

export default getPropertyTypeValue;
